export default __webpack_public_path__ + "29dc92f64de61b44bea1b23f461bf04a.png";